import { Flex } from '@theme-ui/components';
import styled from '@emotion/styled';

import type { LinkProps } from '@app/components/Link';
import Link from '@app/components/Link';
import { rem } from '@app/styles/theme/layout';

const CheckoutBackLink = ({ children, ...linkProps }: LinkProps) => (
  <Link data-testid="checkout-back-link" {...linkProps}>
    <Flex sx={{ alignItems: 'center' }} mr={2}>
      <BackArrow />
      {children}
    </Flex>
  </Link>
);

export default CheckoutBackLink;

const BackArrow = styled.span`
  display: block;
  width: 0;
  height: 0;
  border-top: ${rem(4)} solid transparent;
  border-bottom: ${rem(4)} solid transparent;
  border-right: ${rem(8)} solid currentColor;
  padding-left: ${({ theme }) => theme.space[1]};
  margin-right: ${({ theme }) => theme.space[1]};
`;
